export default "__VITE_ASSET__CVATG4oZ__"